import { Bar } from "react-chartjs-2";
import { useDrag } from "react-dnd";
import { Chart, CategoryScale, LinearScale, BarElement } from "chart.js";
import { Resizable } from "react-resizable";
import React, { useState } from "react";

import "react-resizable/css/styles.css";

Chart.register(CategoryScale, LinearScale, BarElement);

const DraggableChart = ({ data, x = 0, y = 0 }) => {
  const [{ isDragging }, drag] = useDrag({
    type: "CHART",
    item: { type: "CHART", x, y },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const [currentSize, setCurrentSize] = useState({
    width: 400, // Default width
    height: 300, // Default height
  });

  // Handle the resizing event
  const handleResize = (event, data) => {
    const { width, height } = data.size;
    setCurrentSize({ width, height });
  };

  const opacity = isDragging ? 0.5 : 1;

  // Chart options with padding
  const options = {
    layout: {
      padding: {
        left: 40, // Adjust as needed
        right: 10,
        top: 18, // Adjust as needed
        bottom: 10,
      },
    },
  };

  const chartWrapperStyle = {
    position: "relative",
    width: `${currentSize.width}px`,
    height: `${currentSize.height}px`,
  };

  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        opacity,
        border: "solid black 1px",
      }}
    >
      <Resizable
        width={currentSize.width}
        height={currentSize.height}
        onResize={handleResize}
        lockAspectRatio={true} // Lock the aspect ratio
      >
        <div style={chartWrapperStyle}>
          <Bar
            data={data}
            options={options}
            width={currentSize.width}
            height={currentSize.height}
          />
          <div
            ref={drag}
            style={{
              position: "absolute",
              top: "10px",
              left: "10px",
              cursor: "move",
              display: "flex",
            }}
          >
            {/* First icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
              />
            </svg>
            {/* Second icon with margin */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
              style={{ marginLeft: "-18px" }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
              />
            </svg>
          </div>
        </div>
      </Resizable>
    </div>
  );
};

export default DraggableChart;
